module.exports = __webpack_public_path__ + "img/hunt-logo.02f3dee9.jpg";